import type { VueRoute } from "ui-kit/RouterVue";
import { h } from "vue";

const routes: VueRoute[] = [
  {
    path: "/departments/new/:slug?",
    action: async ({ pathname }) => {
      const id = pathname.groups.slug;
      const c = await import("./views/departmentEdit.vue");
      return h(c.default, { id: "new", parentId: id });
    },
  },
  {
    path: "/departments/:slug?",
    action: async ({ pathname }) => {
      const id = pathname.groups.slug;
      const c = id
        ? await import("./views/departmentEdit.vue")
        : await import("./views/departments.vue");
      return h(c.default, { id });
    },
  },
];

export default routes;
